import * as React from 'react';
import TransactionTable from './TransactionTable';
import Dashboard from '../Dashboard/Dashboard';


export default function Transaction() {

  return (
   <Dashboard>
        
       <TransactionTable/>
       </Dashboard>



  );
}
